import classNames from 'classnames';
import type React from 'react';
import { Waypoint } from 'react-waypoint';

export interface ScrollContainerProps {
  onReachBottom?: () => void;
  children: React.ReactNode;
  border?: boolean;
  bottomOffset?: number;
}

export const ScrollContainer = ({
  onReachBottom,
  children,
  border,
  bottomOffset = 300,
}: ScrollContainerProps) => {
  return (
    <div
      className={classNames('h-full w-full overflow-y-auto', {
        'border border-ds-natural-100 rounded-md': border,
      })}
    >
      <div className="relative">
        {children}
        {onReachBottom && (
          <Waypoint
            onEnter={({ previousPosition }) => {
              if (!previousPosition) {
                return;
              }
              onReachBottom();
            }}
          >
            <div
              className="absolute bottom-0 left-0 right-0 bg-transparent pointer-events-none"
              style={{ height: `${bottomOffset}px` }}
            />
          </Waypoint>
        )}
      </div>
    </div>
  );
};
